import { render } from "./ViewEnrollmentTopics.vue?vue&type=template&id=f939b344&scoped=true"
import script from "./ViewEnrollmentTopics.vue?vue&type=script&lang=js"
export * from "./ViewEnrollmentTopics.vue?vue&type=script&lang=js"

import "./ViewEnrollmentTopics.vue?vue&type=style&index=0&id=f939b344&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f939b344"]])

export default __exports__